import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Share2, MessageCircle, UserRound, BadgeCheck, ChevronRight } from "lucide-react";
import { http, formatPrice } from "../../lib/api";
import { siteUrl } from "../../lib/site";

export function ShareButtons({ ad }) {
  const url = `${siteUrl()}/ad/${ad.id}`;
  const text = `${ad.title} - ${formatPrice(ad.price)}\n${ad.taluka || ad.location}, Maharashtra\n99Bazaar Maharashtra वर पहा (नो ब्रोकर):\n${url}`;
  const native = async () => {
    if (navigator.share) {
      try { await navigator.share({ title: ad.title, text, url }); } catch { /* cancelled */ }
    } else {
      await navigator.clipboard?.writeText(url);
      toast.success("Link copied");
    }
  };
  return (
    <div className="flex flex-wrap gap-2">
      <a href={`https://wa.me/?text=${encodeURIComponent(text)}`} target="_blank" rel="noopener noreferrer" className="h-10 px-4 rounded-full bg-[#25D366] hover:bg-[#1ebe5a] text-white text-sm font-semibold flex items-center gap-2 transition-colors" data-testid="share-whatsapp-button">
        <MessageCircle className="w-4 h-4" /> WhatsApp वर Share करा
      </a>
      <button onClick={native} className="h-10 px-4 rounded-full border border-slate-300 hover:border-[var(--navy)] text-sm font-semibold flex items-center gap-2 transition-colors" data-testid="share-link-button">
        <Share2 className="w-4 h-4" /> Share
      </button>
    </div>
  );
}

export function SellerCard({ ownerId }) {
  const [seller, setSeller] = useState(null);
  useEffect(() => {
    if (!ownerId) return;
    http.get(`/sellers/${ownerId}`).then((r) => setSeller(r.data)).catch(() => setSeller(null));
  }, [ownerId]);
  if (!ownerId || !seller) {
    return (
      <div className="bg-white rounded-2xl border border-slate-200 p-4 flex items-center gap-3" data-testid="seller-card">
        <span className="w-11 h-11 rounded-full bg-[var(--orange)] text-white font-bold flex items-center justify-center">99</span>
        <div><p className="font-semibold text-[var(--navy)]">99Bazaar Sample Ad</p><p className="text-xs text-slate-500">नमुना जाहिरात</p></div>
      </div>
    );
  }
  return (
    <Link to={`/seller/${ownerId}`} className="bg-white rounded-2xl border border-slate-200 p-4 flex items-center gap-3 hover:border-[var(--navy)] transition-colors" data-testid="seller-card">
      <span className="w-11 h-11 rounded-full bg-[var(--navy)] text-white font-bold flex items-center justify-center"><UserRound className="w-5 h-5" /></span>
      <div className="min-w-0 flex-1">
        <p className="font-semibold text-[var(--navy)] flex items-center gap-1 truncate" data-testid="seller-card-name">{seller.name} <BadgeCheck className="w-4 h-4 text-[var(--buy)] shrink-0" /></p>
        <p className="text-xs text-slate-500">{seller.taluka}, {seller.district} · {seller.ads.length} जाहिराती</p>
      </div>
      <span className="text-xs font-semibold text-[var(--buy)] flex items-center">Profile <ChevronRight className="w-4 h-4" /></span>
    </Link>
  );
}
